/***************************************************************************************
 * FileName      : index.tsx
 * Description   : 앱 진입점 - Matterport 3D 뷰어 직접 렌더링
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.03
 * Modified Date : 2026.02.09
 * Reference     : 
 ***************************************************************************************/

import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { Main } from './components/Main';

import './main.css';
import { AppState, items, slots } from './AppState';

const appState = new AppState();
appState.items = items;
appState.slots = slots;

// 2026.02.09 : 박은정 : TitleScreen 제거, Main 직접 렌더링 (진입 애니메이션은 Main 내부에서 Sweep 이동으로 처리)
const container = document.getElementById('content');
const root = ReactDOMClient.createRoot(container);
root.render(<Main appState={appState} />);
